export default angular.module("mars.vet.dnareports.controllers.breedlist",[]).controller('BreedListController', function($scope, EntryIDService, EntryService, BreedListService, ImageService, TranslationService) {

    $scope.sortedBreedList = BreedListService.getSortedBreedList(false); // don't include mixed breed groups
    var breedDetails = {}; // collection of breed details
    $scope.loaded = false;
    var entryIdList = [];
    angular.forEach($scope.sortedBreedList, function(value, key) {
        var breedEntryId = EntryIDService.getEntryID(value['breed']);
        entryIdList.push(breedEntryId);
    });
    $scope.translation = TranslationService.getTranslation;
    TranslationService.getGlobalVariablesList().then(function() {
        angular.forEach(entryIdList, function(value, key) {
            EntryService.getEntry(value).then(function(response) {
                var data = response.fields;
                var breedDetail = {};
                breedDetail['breedName'] = data.breedName;
                breedDetail['description'] = data.breedData['History'];
                breedDetail['height'] = data.breedData['Height'];
                breedDetail['weightPet'] = data.breedData['Weight Observed'];
                breedDetail['weightShow'] = data.breedData['Weight'];

                var breedList = BreedListService.getBreedList();
                $scope.count = breedList[data.breedName];
                $scope.percentageValue = ($scope.count * 100) / 8;
                breedDetail['pageTitle'] = data.breedData['Shorter Name'] + ' - ' + $scope.percentageValue + '%';

                var breedCarousel = [];
                var carouselImageList = response.fields.breedCarousel['CarouselImages'];
                if ($scope.carouselImageList != '') {
                    var carouselArray = carouselImageList.split(",");
                    for (var i = 0; i < carouselArray.length; i++) {
                        ImageService.getImageUrl(carouselArray[i]).then(function(response) {
                            breedCarousel.push('https:' + response.data.fields.file.url);
                        });
                    }
                }
                breedDetail['breedCarousel'] = breedCarousel;

                var descriptionArray = [];

                angular.forEach(breedDetail['description'].split("\n"), function(value, key) {
                    if (value != '') {
                        descriptionArray.push(value);
                    }
                });

                breedDetail['descriptionArray'] = descriptionArray;

                var traitsArray = [];

                for (var k = 1; k <= 4; k++) {
                    traitsArray.push(data.breedData['Trait ' + k]);
                }
                breedDetail['traitsArray'] = traitsArray;

                ImageService.getImageUrl(data.breedData['Tail']).then(function(response) {
                    breedDetail['breedTail'] = 'https:' + response.data.fields.file.url;

                });
                ImageService.getImageUrl(data.breedData['Muzzle']).then(function(response) {
                    breedDetail['breedMuzzle'] = 'https:' + response.data.fields.file.url;

                });
                ImageService.getImageUrl(data.breedData['Ear']).then(function(response) {
                    breedDetail['breedEar'] = 'https:' + response.data.fields.file.url;
                });
                ImageService.getImageUrl(data.breedData['Scaled Name']).then(function(response) {
                    breedDetail['breedScale'] = 'https:' + response.data.fields.file.url;
                });
                breedDetails[data.breedName] = breedDetail;

            });
        });
    });
    $scope.breedDetails = breedDetails;
}).name;



// WEBPACK FOOTER //
// ./client/apps/dnareport/controllers/breedlist.controller.js